import { sos } from './hc-config/sos';
import { piaui } from './hc-config/piaui';
import { amapa } from './hc-config/amapa';
import { conexao } from './hc-config/conexao';
import { amazonas } from './hc-config/amazonas';
import { commonEnvironment } from 'src/environments/common';
import { iasep } from './hc-config/iasep';
import { saoPaulo } from './hc-config/sao-paulo';
import { alagoas } from './hc-config/alagoas';

piaui.hcId = commonEnvironment.environmentVariables.healthCenterIdPiaui;
amapa.hcId = commonEnvironment.environmentVariables.healthCenterIdAmapa;
conexao.hcId = commonEnvironment.environmentVariables.healthCenterIdPovosDaFloresta;
amazonas.hcId = commonEnvironment.environmentVariables.healthCenterIdAmazonas;
iasep.hcId = commonEnvironment.environmentVariables.healthCenterIdIasep;
saoPaulo.hcId = commonEnvironment.environmentVariables.healthCenterIdSaoPaulo;
alagoas.hcId = commonEnvironment.environmentVariables.healthCenterIdAlagoas;

export default [sos, piaui, amapa, conexao, amazonas, iasep, saoPaulo, alagoas];
